<div class="createPackage__header" >
  <div class="createPackage__heading">{{createPackageHeader || 'Create Package'}}</div>
  @if (showButton) {
    @if (((draftStatus !== 'Draft') && (draftStatus !== 'Rejected') && (draftStatus !=='Requested')) && selectionMode !=  'RETURN') {
      <div class="createPackage__saveDraft cursor-pointer" (click)="sendToDrafts()">
        @if (buttonClicked) {
          <div class="createPackage__saveDraftIcon"><img src="../../../../assets/Images/create-package/draftSaved.svg" alt="draftSaved"></div>
        }
        @if (loadingIcon) {
          <div>
            <app-common-icon [faIcon]="faSpinner"
            [loadingIcon]="loadingIcon"></app-common-icon>
          </div>
        }
        <div class="createPackage__saveDraftText">Save As Draft</div>
      </div>
    }
  }
  @if (draftStatus === 'Draft' && selectionMode !=  'RETURN' && !isChecker) {
    <div class="createPackage__saveDraft cursor-pointer" (click)="sendToDrafts()">
      @if (buttonClicked) {
        <div class="createPackage__saveDraftIcon"><img src="../../../../assets/Images/create-package/draftSaved.svg" alt="draftSaved"></div>
      }
      @if (loadingIcon) {
        <div>
          <app-common-icon [faIcon]="faSpinner"
          [loadingIcon]="loadingIcon"></app-common-icon>
        </div>
      }
      <div class="createPackage__saveDraftText">Update Draft</div>
    </div>
  }

</div>
